export default "__VITE_ASSET__D09LII4i__"